import { gql } from '@apollo/client';

export const RESOURCE_LOCALIZATIONS_QUERY = gql`
    query resourceLocalizations( $resourceID: UUID! ) {
        resourceLocalizations( resourceID: $resourceID ){
            totalCount
            edges {
                node {
                    id
                    localeCode
                    isDefault
                    resourceFileId
                    name
                    description
                }
            }
        }
    }
`;
